/**
 * Mock flight data for the guided tour demo.
 * All values match the TypeScript types from src/types/api.ts.
 * No API calls are made — these are injected directly into the Zustand store.
 */

import type { Flight, Message, Prediction, Separator, TeamPosition } from '../types/api';

// ── Separators ────────────────────────────────────────────────────────────────

export const MOCK_SEPARATORS: Separator[] = [
  {
    id: 101,
    number: '300234060957310',
    name: 'SEP-001',
    type: 'separator',
    active_flight: true,
    last_flight: { id: 1001, start_time: '2026-06-18T07:30:00Z', end_time: null },
  },
  {
    id: 102,
    number: '300234060957311',
    name: 'SEP-002',
    type: 'separator',
    active_flight: false,
    last_flight: { id: 1002, start_time: '2026-06-18T07:45:00Z', end_time: '2026-06-18T10:30:00Z' },
  },
];

// ── Flights ───────────────────────────────────────────────────────────────────

export const MOCK_FLIGHT_ACTIVE: Flight = {
  id: 1001,
  start_time: '2026-06-18T07:30:00Z',
  end_time: null,
  latitude: 49.45,
  longitude: 4.10,
  separator_name: 'SEP-001',
  separator_imei_id: 101,
  separator_imei_number: '300234060957310',
  payload: 'OMEN-TOUR-A',
};

export const MOCK_FLIGHT_ENDED: Flight = {
  id: 1002,
  start_time: '2026-06-18T07:45:00Z',
  end_time: '2026-06-18T10:30:00Z',
  latitude: 49.29,
  longitude: 4.16,
  separator_name: 'SEP-002',
  separator_imei_id: 102,
  separator_imei_number: '300234060957311',
  payload: 'OMEN-TOUR-B',
};

// ── Messages — active flight (12 entries, ascending) ─────────────────────────

export const MOCK_MESSAGES_ACTIVE: Message[] = [
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:30:00Z', latitude: 48.900, longitude: 3.800, altitude: 500,   speed: 4.2, sep_altitude: 28000, status: 'm', Temp: 18.5,  Plev: 950, u_bat: 4.1, n_sats: 10, timer: 0,  payload: 'OMEN-TOUR-A' },
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:31:00Z', latitude: 48.950, longitude: 3.827, altitude: 1727,  speed: 4.3, sep_altitude: 28000, status: 'm', Temp: 13.9,  Plev: 877, u_bat: 4.1, n_sats: 10, timer: 6,  payload: 'OMEN-TOUR-A' },
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:32:00Z', latitude: 49.000, longitude: 3.855, altitude: 2954,  speed: 4.5, sep_altitude: 28000, status: 'm', Temp: 9.3,   Plev: 803, u_bat: 4.1, n_sats: 10, timer: 12, payload: 'OMEN-TOUR-A' },
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:33:00Z', latitude: 49.050, longitude: 3.882, altitude: 4181,  speed: 4.6, sep_altitude: 28000, status: 'm', Temp: 4.7,   Plev: 730, u_bat: 4.1, n_sats: 10, timer: 18, payload: 'OMEN-TOUR-A' },
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:34:00Z', latitude: 49.100, longitude: 3.909, altitude: 5409,  speed: 4.7, sep_altitude: 28000, status: 'm', Temp: 0.1,   Plev: 656, u_bat: 4.1, n_sats: 10, timer: 24, payload: 'OMEN-TOUR-A' },
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:35:00Z', latitude: 49.150, longitude: 3.936, altitude: 6636,  speed: 4.9, sep_altitude: 28000, status: 'm', Temp: -4.5,  Plev: 583, u_bat: 4.1, n_sats: 10, timer: 30, payload: 'OMEN-TOUR-A' },
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:36:00Z', latitude: 49.200, longitude: 3.964, altitude: 7863,  speed: 5.0, sep_altitude: 28000, status: 'm', Temp: -9.1,  Plev: 510, u_bat: 4.1, n_sats: 10, timer: 36, payload: 'OMEN-TOUR-A' },
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:37:00Z', latitude: 49.250, longitude: 3.991, altitude: 9090,  speed: 5.2, sep_altitude: 28000, status: 'm', Temp: -13.7, Plev: 436, u_bat: 4.1, n_sats: 10, timer: 42, payload: 'OMEN-TOUR-A' },
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:38:00Z', latitude: 49.300, longitude: 4.018, altitude: 10318, speed: 5.3, sep_altitude: 28000, status: 'm', Temp: -18.3, Plev: 363, u_bat: 4.1, n_sats: 10, timer: 48, payload: 'OMEN-TOUR-A' },
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:39:00Z', latitude: 49.350, longitude: 4.045, altitude: 11545, speed: 5.5, sep_altitude: 28000, status: 'm', Temp: -22.9, Plev: 289, u_bat: 4.0, n_sats: 10, timer: 54, payload: 'OMEN-TOUR-A' },
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:40:00Z', latitude: 49.400, longitude: 4.073, altitude: 12772, speed: 5.6, sep_altitude: 28000, status: 'm', Temp: -27.5, Plev: 216, u_bat: 4.0, n_sats: 9,  timer: 60, payload: 'OMEN-TOUR-A' },
  { flight_id: 1001, name: 'SEP-001', timestamp: '2026-06-18T07:41:00Z', latitude: 49.450, longitude: 4.100, altitude: 14000, speed: 5.8, sep_altitude: 28000, status: 'm', Temp: -32.0, Plev: 142, u_bat: 4.0, n_sats: 9,  timer: 66, payload: 'OMEN-TOUR-A' },
];

// ── Messages — ended flight (20 entries, full arc) ────────────────────────────

export const MOCK_MESSAGES_ENDED: Message[] = [
  // Ascent phase (i=0..8): 0 → 25000 m, status "m"
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T07:45:00Z', latitude: 48.950, longitude: 3.850, altitude: 0,     speed: 3.8, sep_altitude: 28000, status: 'm', Temp: 15.0,  Plev: 1013, u_bat: 4.1, n_sats: 11, timer: 0,   payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T07:54:00Z', latitude: 49.011, longitude: 3.889, altitude: 3111,  speed: 4.1, sep_altitude: 28000, status: 'm', Temp: 7.2,   Plev: 903,  u_bat: 4.1, n_sats: 11, timer: 9,   payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T08:02:00Z', latitude: 49.072, longitude: 3.928, altitude: 6222,  speed: 4.3, sep_altitude: 28000, status: 'm', Temp: -0.6,  Plev: 793,  u_bat: 4.1, n_sats: 11, timer: 17,  payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T08:11:00Z', latitude: 49.133, longitude: 3.967, altitude: 9333,  speed: 4.5, sep_altitude: 28000, status: 'm', Temp: -8.4,  Plev: 283,  u_bat: 4.1, n_sats: 10, timer: 26,  payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T08:20:00Z', latitude: 49.194, longitude: 4.006, altitude: 12444, speed: 4.6, sep_altitude: 28000, status: 'm', Temp: -16.2, Plev: 183,  u_bat: 4.1, n_sats: 10, timer: 35,  payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T08:29:00Z', latitude: 49.255, longitude: 4.044, altitude: 15556, speed: 4.8, sep_altitude: 28000, status: 'm', Temp: -24.0, Plev: 113,  u_bat: 4.1, n_sats: 10, timer: 44,  payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T08:38:00Z', latitude: 49.317, longitude: 4.083, altitude: 18667, speed: 5.0, sep_altitude: 28000, status: 'm', Temp: -31.8, Plev: 73,   u_bat: 4.1, n_sats: 10, timer: 53,  payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T08:47:00Z', latitude: 49.378, longitude: 4.122, altitude: 21778, speed: 5.2, sep_altitude: 28000, status: 'm', Temp: -39.6, Plev: 53,   u_bat: 4.0, n_sats: 10, timer: 62,  payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T08:56:00Z', latitude: 49.439, longitude: 4.161, altitude: 24889, speed: 5.3, sep_altitude: 28000, status: 'm', Temp: -47.4, Plev: 33,   u_bat: 4.0, n_sats: 9,  timer: 71,  payload: 'OMEN-TOUR-B' },
  // Separation peak (i=9): 28000 m, status "c"
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T09:05:00Z', latitude: 49.500, longitude: 4.200, altitude: 28000, speed: 0.0, sep_altitude: 28000, status: 'c', Temp: -55.0, Plev: 25,   u_bat: 4.0, n_sats: 9,  timer: 80,  payload: 'OMEN-TOUR-B' },
  // Descent phase (i=10..19): 28000 → 13280 m, status "d"
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T09:14:00Z', latitude: 49.479, longitude: 4.196, altitude: 26528, speed: 6.2, sep_altitude: 28000, status: 'd', Temp: -52.5, Plev: 32,   u_bat: 4.0, n_sats: 9,  timer: 89,  payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T09:23:00Z', latitude: 49.458, longitude: 4.192, altitude: 25056, speed: 6.5, sep_altitude: 28000, status: 'd', Temp: -50.0, Plev: 39,   u_bat: 4.0, n_sats: 9,  timer: 98,  payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T09:32:00Z', latitude: 49.437, longitude: 4.188, altitude: 23584, speed: 6.8, sep_altitude: 28000, status: 'd', Temp: -47.5, Plev: 47,   u_bat: 4.0, n_sats: 9,  timer: 107, payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T09:41:00Z', latitude: 49.416, longitude: 4.184, altitude: 22112, speed: 7.0, sep_altitude: 28000, status: 'd', Temp: -45.0, Plev: 56,   u_bat: 4.0, n_sats: 10, timer: 116, payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T09:50:00Z', latitude: 49.395, longitude: 4.180, altitude: 20640, speed: 7.3, sep_altitude: 28000, status: 'd', Temp: -42.5, Plev: 67,   u_bat: 4.0, n_sats: 10, timer: 125, payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T09:59:00Z', latitude: 49.374, longitude: 4.176, altitude: 19168, speed: 7.5, sep_altitude: 28000, status: 'd', Temp: -39.5, Plev: 80,   u_bat: 4.0, n_sats: 10, timer: 134, payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T10:08:00Z', latitude: 49.353, longitude: 4.172, altitude: 17696, speed: 7.7, sep_altitude: 28000, status: 'd', Temp: -36.0, Plev: 95,   u_bat: 4.0, n_sats: 10, timer: 143, payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T10:17:00Z', latitude: 49.332, longitude: 4.168, altitude: 16224, speed: 7.9, sep_altitude: 28000, status: 'd', Temp: -33.0, Plev: 113,  u_bat: 4.0, n_sats: 10, timer: 152, payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T10:24:00Z', latitude: 49.311, longitude: 4.164, altitude: 14752, speed: 8.1, sep_altitude: 28000, status: 'd', Temp: -30.5, Plev: 134,  u_bat: 4.0, n_sats: 10, timer: 159, payload: 'OMEN-TOUR-B' },
  { flight_id: 1002, name: 'SEP-002', timestamp: '2026-06-18T10:28:00Z', latitude: 49.290, longitude: 4.160, altitude: 13280, speed: 8.3, sep_altitude: 28000, status: 'd', Temp: -28.0, Plev: 170,  u_bat: 4.0, n_sats: 10, timer: 163, payload: 'OMEN-TOUR-B' },
];

// ── Predictions ───────────────────────────────────────────────────────────────

export const MOCK_PREDICTION_NORMAL: Prediction = {
  type: 'normal',
  landing_time: '2026-06-18T11:20:00Z',
  city: 'Le Châtelet-sur-Retourne',
  city_distance_km: 1.3,
  latitude: 49.417,
  longitude: 4.292,
  polygon_points: [
    [4.27, 49.40], [4.31, 49.40], [4.31, 49.43], [4.27, 49.43], [4.27, 49.40],
  ],
  heatmap_points: [
    [4.285, 49.412], [4.290, 49.417], [4.295, 49.415],
  ],
};

export const MOCK_PREDICTION_INSTANT: Prediction = {
  type: 'instant',
  landing_time: '2026-06-18T10:55:00Z',
  city: 'Rethel',
  city_distance_km: 4.8,
  latitude: 49.508,
  longitude: 4.364,
  polygon_points: [
    [4.34, 49.49], [4.39, 49.49], [4.39, 49.53], [4.34, 49.53], [4.34, 49.49],
  ],
  heatmap_points: [
    [4.360, 49.505], [4.364, 49.508], [4.368, 49.503],
  ],
};

// ── Team positions ────────────────────────────────────────────────────────────

export const MOCK_TEAMS: TeamPosition[] = [
  {
    terminal_name: 'TAB-001',
    team_name: 'Équipe Alpha',
    user_name: 'Alice Martin',
    followed_separator_name: 'SEP-001',
    latitude: 49.12,
    longitude: 3.95,
    timestamp: '2026-06-18T07:40:00Z',
  },
  {
    terminal_name: 'TAB-002',
    team_name: 'Équipe Bravo',
    user_name: 'Bob Dupont',
    followed_separator_name: 'SEP-001',
    latitude: 49.08,
    longitude: 4.02,
    timestamp: '2026-06-18T07:39:00Z',
  },
];
